// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const inventory: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="inventory Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [
   
    {
      id: 'inventory',
      title: <FormattedMessage id="Inventory" />,
      type: 'collapse',
      icon: icons.inventory,
      children: [
        {
          id: 'inventory-list',
          title: <FormattedMessage id="inventory-list" />,
          type: 'item',
          url: '/apps/inventory/inventory-list',
          breadcrumbs: false
        },
        {
          id: 'inventory-details',
          title: <FormattedMessage id="Inventory Details" />,
          type: 'item',
          url: '/apps/inventory/inventory-details',
          breadcrumbs: false
        },
        {
          id: 'add-new-inventory',
          title: <FormattedMessage id="add-new-inventory" />,
          type: 'item',
          url: '/apps/inventory/add-new-inventory'
        }
      ]
    },
    {
      id: 'inventory-pack',
      title: <FormattedMessage id="Inventory Pack Name" />,
      type: 'collapse',
      icon: icons.inventory,
      children: [
        {
          id: 'inventory-pack-list',
          title: <FormattedMessage id="inventory-pack-list" />,
          type: 'item',
          url: '/apps/inventory-pack/inventory-pack-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-inventory-pack',
          title: <FormattedMessage id="add-new-inventory-pack" />,
          type: 'item',
          url: '/apps/inventory-pack/add-new-inventory-pack'
        }
      ]
    },
  ]
};

export default inventory;
